import { toCssVariables } from '@smoothie-framework/ui-styles/theme-css';
const appliedCssVariableKeys = new WeakMap();
function resolvePrefix(prefix) {
    return prefix ?? '--smth';
}
function resolveTarget(target) {
    if (target) {
        return target;
    }
    if (typeof document === 'undefined') {
        return null;
    }
    return document.documentElement;
}
function setThemeScopeAttribute(target, attributeName, value) {
    if (value === undefined) {
        return;
    }
    if (value === null || value.length === 0) {
        target.removeAttribute(attributeName);
        return;
    }
    target.setAttribute(attributeName, value);
}
export function applyThemeCssVariables(theme, options = {}) {
    const target = resolveTarget(options.target);
    if (!target) {
        return;
    }
    const prefix = resolvePrefix(options.prefix);
    const cssVars = toCssVariables(theme, {
        prefix,
        includeTextStyles: options.includeTextStyles ?? true,
    });
    const nextKeys = new Set(Object.keys(cssVars));
    const previousKeys = appliedCssVariableKeys.get(target);
    if (previousKeys) {
        for (const key of previousKeys) {
            if (!nextKeys.has(key)) {
                target.style.removeProperty(key);
            }
        }
    }
    for (const [key, value] of Object.entries(cssVars)) {
        target.style.setProperty(key, String(value));
    }
    appliedCssVariableKeys.set(target, nextKeys);
}
export function applyThemeScopeAttributes(options = {}) {
    const target = resolveTarget(options.target);
    if (!target) {
        return;
    }
    setThemeScopeAttribute(target, 'data-smth-theme', options.mode);
    setThemeScopeAttribute(target, 'data-smth-brand', options.brand);
}
//# sourceMappingURL=css_vars.js.map